import { Component, computed, input } from '@angular/core';

import { ImageComponentModel } from '@ppg/core/models';
import { ImageComponent, FallbackImageComponent } from '@ppg/shared/components';

@Component({
  selector: 'ppg-card-image-with-fallback',
  standalone: true,
  imports: [FallbackImageComponent, ImageComponent],
  templateUrl: './card-image-with-fallback.component.html',
})
export class CardImageWithFallbackComponent {
  readonly image = input<ImageComponentModel>();

  readonly imgUrl = computed(() => this.image()?.url ?? '');
  readonly imgHeight = computed(() => this.image()?.height ?? 0);
  readonly imgWidth = computed(() => this.image()?.width ?? 0);
  readonly imgDescription = computed(() => this.image()?.description ?? '');
}
